import { observer } from 'mobx-react-lite';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import updateRequiredImg from '~/assets/img/update-required.png';
import { company } from '~/company/Company';
import { Button } from '~/components/isolated/Button';
import Modal from '~/components/Modal/Modal';
import { mainStore } from '~/stores';

import styles from './ModalUpdateRequired.module.scss';

const ModalUpdateRequired = () => {
  const { t } = useTranslation();

  const handleGoToUpdate = () => {
    const storeUrl =
      mainStore.appPlatform === 'ios'
        ? company.config.appStoreUrl?.ios
        : company.config.appStoreUrl?.android;

    if (storeUrl) {
      mainStore.sendToRN('openInAppBrowser', { url: storeUrl });
    }
  };

  const modal = (
    <Modal isShow={true} className={styles.root} onBackdropDismiss={noop}>
      <div className={styles.content}>
        <div className={styles.imageWrapper}>
          <img
            src={updateRequiredImg}
            alt="Update Required"
            className={styles.image}
          />
        </div>
        <h1 className={styles.title}>{t('updateRequired:title')}</h1>
        <p className={styles.description}>{t('updateRequired:description')}</p>

        <Button
          onClick={handleGoToUpdate}
          size="L"
          variant="primary"
          className={styles.button}
        >
          {t('updateRequired:goToUpdate')}
        </Button>
      </div>
    </Modal>
  );

  return createPortal(modal, document.body);
};

const noop = () => void 0;

export default observer(ModalUpdateRequired);
